import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApi, postApi } from "../../../services/apiServices";
import {
  ALL_PRODUCTS_LIST,
  ALL_PRODUCTS_PRICING,
  BLANKET_ORDERS_LIST_WITH_PENDING_SUB_ORDERS_BY_DEALER,
  DRAFT_ORDERS_LIST,
  FAILED_ORDERS_LIST,
  ORDER_REQUEST_LIST,
  ORDERS_LIST,
  SUB_ORDERS_LIST,
  SUB_ORDERS_LIST_DEALER,
} from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";

/*---------------- Order Requests List ---------------- */
export const OrderRequestsList = createAsyncThunk(
  "Order_Requests_List/admin",
  async (reqData) => {
    try {
      const url = `${ORDER_REQUEST_LIST}?orderBy=${encodeURIComponent(
        reqData.orderBy
      )}&search=${encodeURIComponent(reqData.search)}&page=${encodeURIComponent(
        reqData.page
      )}`;
      const response = await getApi(url);
      // console.log("Order requests list is :", response);
      return response;
    } catch (error) {
      console.log("Error Order Request List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Orders List ---------------- */
export const OrdersListAPI = createAsyncThunk(
  "Orders_List/admin",
  async (reqData) => {
    try {
      const url = `${ORDERS_LIST}?search=${encodeURIComponent(
        reqData.search
      )}&page=${encodeURIComponent(
        reqData.page
      )}&orderType=${encodeURIComponent(reqData?.orderType)}`;
      const response = await getApi(url);
      // console.log("Orders list is :", response);
      return response;
    } catch (error) {
      console.log("Error Orders List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Blanket Orders List with Pending Sub Orders from Dealer ---------------- */
export const BlanketOrdersListPendingSubOrderAPI = createAsyncThunk(
  "Orders_List_with_pending_sub_orders_from_dealer/admin",
  async (reqData) => {
    try {
      const url = `${BLANKET_ORDERS_LIST_WITH_PENDING_SUB_ORDERS_BY_DEALER}?search=${encodeURIComponent(
        reqData.search
      )}&page=${encodeURIComponent(
        reqData.page
      )}&orderType=${encodeURIComponent(reqData?.orderType)}`;
      const response = await getApi(url);
      // console.log("Orders list is :", response);
      return response;
    } catch (error) {
      console.log("Error Orders List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Failed Orders List ---------------- */
export const FailedOrdersListAPI = createAsyncThunk(
  "Failed_Orders_List/admin",
  async (reqData) => {
    try {
      const url = `${FAILED_ORDERS_LIST}?search=${encodeURIComponent(
        reqData.search
      )}&page=${encodeURIComponent(reqData.page)}`;
      const response = await getApi(url);
      // console.log("Failed Orders list is :", response);
      return response;
    } catch (error) {
      console.log("Error Failed Orders List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
/*---------------- Draft Orders List ---------------- */
export const DraftOrdersListAPI = createAsyncThunk(
  "Draft_Orders_List/admin",
  async (reqData) => {
    try {
      const url = `${DRAFT_ORDERS_LIST}?search=${encodeURIComponent(
        reqData.search
      )}&page=${encodeURIComponent(reqData.page)}`;
      const response = await getApi(url);
      // console.log("Draft Orders list is :", response);
      return response;
    } catch (error) {
      console.log("Error Draft Orders List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- All Products List ---------------- */
export const AllProductsListAPI = createAsyncThunk(
  "All_Products_List/admin",
  async (reqData) => {
    try {
      const url = `${ALL_PRODUCTS_LIST}?page=${encodeURIComponent(
        reqData.currentPage
      )}&perPage=${encodeURIComponent(reqData.perPage)}`;
      const response = await getApi(url);
      // console.log("All Products list is :", response);
      return response;
    } catch (error) {
      console.log("Error All Products List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
/*---------------- All Products Pricing List ---------------- */
export const AllProductsPricingListAPI = createAsyncThunk(
  "All_Products_List/admin",
  async (reqData) => {
    try {
      const url = `${ALL_PRODUCTS_PRICING}?page=${encodeURIComponent(
        reqData.currentPage
      )}&perPage=${encodeURIComponent(reqData.perPage)}`;
      const response = await getApi(url);
      // console.log("All Products Pricing List is :", response);
      return response;
    } catch (error) {
      console.log("Error All Products Pricing List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*---------------- Sub Orders List ---------------- */
export const SubOrdersListAPI = createAsyncThunk(
  "Sub_Orders_List/admin",
  async (reqData) => {
    try {
      const url = `${SUB_ORDERS_LIST}?page=${encodeURIComponent(
        reqData.currentPage
      )}`;
      const response = await postApi(url, reqData);
      // console.log("Sub Orders list is :", response);
      return response;
    } catch (error) {
      console.log("Error Sub Orders List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
/*---------------- Sub Orders List for Dealer ---------------- */
export const SubOrdersListDealerAPI = createAsyncThunk(
  "Sub_Orders_Dealer_List/admin",
  async (reqData) => {
    try {
      const url = `${SUB_ORDERS_LIST_DEALER}?page=${encodeURIComponent(
        reqData.currentPage
      )}`;
      const response = await postApi(url, reqData);
      // console.log("Sub Orders list is :", response);
      return response;
    } catch (error) {
      console.log("Error Sub Orders List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
